var map = {
	"./chair01.jpg": 7664,
	"./chair02.jpg": 501,
	"./chair03.jpg": 1848,
	"./chair04.jpg": 2257,
	"./chair05.jpg": 8577,
	"./chair06.jpg": 8258,
	"./chair07.jpg": 8606,
	"./chair08.jpg": 5697,
	"./chair09.jpg": 2968,
	"./chair10.jpg": 7817,
	"./chair11.jpg": 9527,
	"./chair12.jpg": 9577,
	"./chair13.jpg": 8278,
	"./chair14.jpg": 9837,
	"./chair15.jpg": 961,
	"./chair16.jpg": 9055,
	"./light01.jpg": 3267,
	"./light02.jpg": 1331,
	"./light03.jpg": 7101,
	"./light04.jpg": 4963,
	"./light05.jpg": 4708,
	"./light06.jpg": 5689,
	"./light07.jpg": 1023,
	"./light08.jpg": 4150,
	"./light09.jpg": 1223,
	"./light10.jpg": 8721,
	"./light11.jpg": 9043,
	"./light12.jpg": 2157,
	"./light13.jpg": 4117,
	"./light14.jpg": 9874,
	"./light15.jpg": 2443,
	"./light16.jpg": 4014
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2169;